import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../API";
import { Container } from "react-bootstrap";
import "./ShopBanner.css";
import Slider from ".././Slider";
import { settingsBanners } from "../../Config/Slider";
const ShopBanner = ({ banner }) => {
    // const [banner, setBanner] = useState(null);
    // const [loading, setLoading] = useState(true);

    const dummyBanner = {
        image: "https://picsum.photos/1200/400",
        title: "Welcome to Our Shop",
        description: "Explore our latest collection and amazing offers.",
    };



    // useEffect(() => {
    //     async function fetchData() {

    //         try {
    //             const res = await axios.get(`${API}/api/shop-banner`, {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                 },
    //             });
    //             setBanner(res?.data);
    //         } catch (error) {
    //             console.error("Error fetching the banner:", error.response?.data?.message || error.message);
    //             setBanner(dummyBanner);
    //         } finally {
    //             setLoading(false);
    //         }
    //     }
    //     fetchData();
    // }, []);

    // if (loading) {
    //     return (
    //         <div className="loading-indicator">
    //             {/* Animated dots for modern loading */}
    //             <div className="dot"></div>
    //             <div className="dot"></div>
    //             <div className="dot"></div>
    //         </div>
    //     );
    // }

    return (
        <Container fluid className="p-0 mb-4">
            <div className="position-relative">
                {banner?.length ? (
                    <Slider data={banner} settings={settingsBanners} />
                ) : (
                    <div className="d-flex justify-content-center align-items-center w-100">
                        <div className="position-relative w-100">
                            <img
                                src={dummyBanner.image} // Replace with your dummy image URL
                                alt={dummyBanner.title || "Default Banner"}
                                className="img-fluid w-100"
                                style={{ maxHeight: '400px', objectFit: 'cover' }} // Control the image height and prevent stretching
                            />
                            <div className="position-absolute top-50 start-50 translate-middle text-white text-center">
                                <h2 className="fs-3">{dummyBanner.title || "Welcome to Our Shop!"}</h2>
                                <p>{dummyBanner.description || "Explore our amazing products."}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Container>

    );
};

export default ShopBanner;
